import React, { useState, useEffect, useCallback } from 'react';
import { Modal, Button, Table, Form } from 'react-bootstrap';
import { postData } from '../../../utility/Utility';
import { toast } from 'react-toastify';
import ReactPaginate from 'react-paginate';
import CustomLoader from '../../../Components/CustomLoader/CustomLoader';

export default function RoleModel({ onClose, onSelect }) {
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [roleFilter, setRoleFilter] = useState('');
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);
  const rowsPerPage = 10;

  // Handle page change
  const handlePageChange = (selectedItem) => {
    setCurrentPage(selectedItem.selected);
  };

  const fetchUsers = useCallback(async (role, searchTerm) => {
    setLoading(true);
    try {
      const response = await postData("api/employees/list", {
        limit: rowsPerPage,
        page: currentPage + 1,
        role: role,
        search: searchTerm
      });

      if (response.status) {
        setUsers(response.data);
        setTotalPages(response.pagination.pages);
      } else {
        toast.error(response.message || "Failed to fetch users");
      }
    } catch (error) {
      toast.error("Error fetching users");
      console.error("Fetch users error:", error);
    } finally {
      setLoading(false);
    }
  }, [currentPage, rowsPerPage]);

  useEffect(() => {
    fetchUsers(roleFilter, searchTerm);
  }, [fetchUsers, roleFilter, searchTerm]);

  return (
    <Modal show={true} onHide={onClose} size="lg">
      <CustomLoader loading={loading} />
      <Modal.Header closeButton>
        <Modal.Title>Select User</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex mb-3 gap-2">
          <Form.Control
            type="search"
            placeholder="Search users..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <div className="row mt-2">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                {loading ? (
                  <div className="text-center py-5">
                    <CustomLoader loading={true} />
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Phone</th>
                          <th>Designation</th>
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {users.length > 0 ? (
                          users.map((user, index) => (
                            <tr key={user._id}>
                              <td>{currentPage * rowsPerPage + index + 1}</td>
                              <td>{user.username}</td>
                              <td>{user.email}</td>
                              <td>{user.contactNumber}</td>
                              <td>{user.designation}</td>
                              <td>{user.isActive ? 'Active' : 'Inactive'}</td>
                              <td>
                                <button
                                  className="btn btn-sm btn-outline-primary"
                                  onClick={() => onSelect(user)}
                                >
                                  Select
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="7" className="text-center py-4">
                              No users found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>

                    {totalPages > 1 && (
                      <div className="d-flex justify-content-end">
                        <ReactPaginate
                          previousLabel={<i className="mdi mdi-chevron-left"></i>}
                          nextLabel={<i className="mdi mdi-chevron-right"></i>}
                          breakLabel="..."
                          breakClassName="page-item"
                          breakLinkClassName="page-link"
                          pageCount={totalPages}
                          marginPagesDisplayed={2}
                          pageRangeDisplayed={5}
                          onPageChange={handlePageChange}
                          containerClassName="pagination pagination-rounded"
                          pageClassName="page-item"
                          pageLinkClassName="page-link"
                          previousClassName="page-item"
                          previousLinkClassName="page-link"
                          nextClassName="page-item"
                          nextLinkClassName="page-link"
                          activeClassName="active"
                          forcePage={currentPage}
                        />
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}